import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { useFirestoreGeneral } from '../../firebase/useFirestore';
import Location from "../../hooks/Location"
import DeleteModal from "../../components/common/DeleteModal";
import robotImage from "../../images/icons/robot-icon.png"
import plusButton from '../../images/icons/plus-icon.png'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Tooltip from "../../components/common/Tooltip";
import DraggableTableItems from "../../components/common/DraggableTableItems";
import { useContext, useState, useEffect } from 'react';
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { db } from '../../firebase/config';
import { v4 as uuid } from 'uuid';
import useSettings from "../../hooks/Settings";
import softDeleteDoc from '../../helpers/softDeleteDoc';
import { Auth } from '../../StateManagment/Auth';
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import IconButton from '../../components/common/IconButton';

const ResearchAnalysis = () => {
  // Context
  const [saved, setSaved] = useContext(SavedIcon)
  const [auth] = useContext(Auth)

  // State
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteDocid, setDeleteDocid] = useState('')
  const [deleteName, setDeleteName] = useState('')
  const [placeholderIndex, setPlaceholderIndex] = useState(null)
  const [hoverIndex, setHoverIndex] = useState(null)
  const [hightlighted, setHightlighted] = useState(false)
  const [hightlightText, setHightlightText] = useState('')
  const [chatOpen, setChatOpen] = useState(false)


  // Hooks
  const researchId = Location()[3]
  const { secundairyColor } = useSettings()

  // Firestore
  const researchInsights = useFirestoreGeneral('ResearchInsights', 'ResearchID', researchId ? researchId : '')

  // Delete modal 
  const deleteModalHandler = (e) => {
    const docid = e.currentTarget.dataset.docid
    const deleteName = e.currentTarget.dataset.deletename

    setDeleteDocid(docid)
    setDeleteName(deleteName)

    setDeleteModal(!deleteModal)
}

// Add insight
const addInsights = () => {
    db.collection('ResearchInsights').add({
        Title: '',
        ResearchID: researchId,
        ID: uuid()
    })
    .then(() => {
        setSaved('flex')
    })
}

// Delete insight
// Zacht (ADR-008), op de eigen collectie. Tot 2026-10-02 schoot dit hard op
// 'Questionnaires' met de docid van het inzicht, waardoor het inzicht bleef staan.
// Geen `softDelete` op de DeleteModal: inzichten dragen geen CompagnyID, dus de
// prullenbak (die per organisatie zoekt) toont ze niet — beloof dat dan ook niet.
const deleteInsight = async () => {
    await softDeleteDoc({ collection: 'ResearchInsights', docid: deleteDocid, authId: auth?.ID, title: deleteName })
    setSaved('flex')
    setDeleteModal(false)
}

    // Reset hightlights
    useEffect(() => {
      setHightlighted(false)
      setHightlightText('')
  },[])

   // Hightlight impactAI
   const impactaiHandler = () => {
      setChatOpen(true)
      setHightlighted(!hightlighted)
      setHightlightText('Ja, ga je gang!')
  }

  // Title handler
  const titleHandler = (e) => {
    const docid = e.target.dataset.docid
    const value = e.target.value

    db.collection('ResearchInsights')
    .doc(docid)
    .update({
        Title: value
    })
    .then(() => {
        setSaved('flex')
    })
}

  return (
    <div className="main">
        <div className="main-container" >
            <div className='page-header'>
                <LightbulbOutlinedIcon/>
                <h1>Onderzoeksinzichten</h1>
            </div>
            <ReadOnlyGuard edit="measurement.edit">
                {(canEdit) => (
                    <div className="table-container dashboard-container">
                        <div className='list-top-row-container'>
                            {canEdit && (
                                <Tooltip content={'Vragenlijst toevoegen'} width={'30px'} top='35px'>
                                    <IconButton icon={plusButton} label='Vragenlijst toevoegen' onClick={addInsights} />
                                </Tooltip>
                            )}
                            <Tooltip content={'Kan ik je helpen?'} width={'30px'} top='-10px' left='30px'>
                                <img src={robotImage} alt="" className="ai-assistant-icon" onClick={impactaiHandler}/>
                            </Tooltip>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>INZICHT</th>
                                    <th>DATA</th>
                                    <th>VERWIJDER</th>
                                </tr>
                            </thead>
                            {researchInsights && researchInsights.map((item, index) => (
                                <>
                                    {placeholderIndex === index && (
                                        <tr className="placeholder-row">
                                            <td className="secondary-table-cell"></td>
                                        </tr>
                                    )}
                                    <DraggableTableItems
                                    item={item}
                                    input={
                                        <Tooltip content={item.Title} width='100%' top='-60px'>
                                            <input type="text" placeholder="Schrijf hier de titel" data-docid={item.docid} defaultValue={item.Title} onChange={titleHandler}/>
                                        </Tooltip>
                                    }
                                    parentIndex={index}
                                    collection={'ResearchInsights'}
                                    itemArray={researchInsights}
                                    setHoverIndex={setHoverIndex}
                                    hoverIndex={hoverIndex}
                                    title={item.Title}
                                    setPlaceholderIndex={setPlaceholderIndex}
                                    >

                                        <td>

                                        </td>

                                        <td>
                                            {canEdit && (
                                                <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} data-deletename={item.Title} onClick={deleteModalHandler} />
                                            )}
                                        </td>
                                    </DraggableTableItems>
                                </>
                            ))}
                        </table>
                    </div>
                )}
            </ReadOnlyGuard>
        </div>
        <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteInsight} deleteName={deleteName} />
    </div>
  )
}

export default ResearchAnalysis